import * as React from "react";
import { ChildProps, graphql } from "react-apollo";
import gql from "graphql-tag";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import columnConfigFactory, {
  GqlWithdrawalRequest,
} from "./withdrawalRequestsColumns";
import { RouteComponentProps, withRouter } from "react-router";

const PAGE_LIMIT = 20;

type GqlQueryResult = {
  user: {
    email: string;
    withdrawal_requests: Array<GqlWithdrawalRequest>;
  };
};

type Props = ChildProps<
  {
    name: string;
    onLoaded: (email: string) => void;
    createdAtFrom: string;
    createdAtTo: string;
  } & BOComponentProps &
    RouteComponentProps<{ id: string }> &
    PaginationProps,
  GqlQueryResult
>;

class UserWithdrawalRequestsContainer extends React.Component<Props> {
  onWithhold() {
    this.props.data.refetch();
  }

  render() {
    const withdrawals = this.props.data.user?.withdrawal_requests || [];

    return (
      <BOGraphQLLoader
        data={this.props.data}
        onLoaded={() => this.props.onLoaded(this.props.data.user?.email)}
      >
        <ConfigurableTable
          name={this.props.name}
          pagination={this.props.pagination}
          columnConfigs={columnConfigFactory(this.onWithhold.bind(this))}
          defaultColumns={[
            "Created At",
            "Payable Amount",
            "Status",
            "Batch",
            "Fraud Status",
            "Action",
          ]}
          rows={withdrawals}
          rowToLink={(withdrawal: GqlWithdrawalRequest) =>
            `/snapscan/wallet_withdrawals/${withdrawal.reference}/summary`
          }
          history={this.props.history}
        />
      </BOGraphQLLoader>
    );
  }
}

const withdrawalListGql = gql`
  query UserWalletWithdrawalRequests(
    $offset: Int
    $limit: Int
    $createdAtFrom: String
    $createdAtTo: String
    $userExternalReference: ID
  ) {
    user(external_reference: $userExternalReference) {
      email
      withdrawal_requests(
        offset: $offset
        limit: $limit
        created_at_from: $createdAtFrom
        created_at_to: $createdAtTo
      ) {
        created_at
        reference
        status
        user {
          external_reference
          email
          snapmin_url
          devices {
            external_reference
            updated_at
            device_only_fraud_status
            token
            suspicious_token_status
            suspicious_token_comments {
              comment
              status
              updated_at
              user
            }
            phone_number
            suspicious_phone_number_status
            suspicious_phone_number_comments {
              comment
              status
              updated_at
              user
            }
          }
        }
        payable_amount
        withdrawal_batch {
          id
          status
        }
      }
    }
  }
`;

const withWithdrawalsGqlData = graphql<GqlQueryResult, Props>(
  withdrawalListGql,
  {
    options: (props) => {
      const {
        createdAtFrom,
        createdAtTo,
        pagination: { offset, limit },
      } = props;

      return {
        fetchPolicy: "network-only",
        variables: {
          userExternalReference: props.match.params.id,
          createdAtFrom,
          createdAtTo,
          offset,
          limit,
        },
      };
    },
  }
);

export default withPagination(
  withRouter(withWithdrawalsGqlData(UserWithdrawalRequestsContainer)),
  PAGE_LIMIT
);
